import { Link } from 'react-router-dom';
import { Search, Menu, X } from 'lucide-react';
import { useState } from 'react';
import { ThemeToggle } from '@/components/ui/ThemeToggle';

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 glass border-b border-surface-200/50">
      <div className="max-w-6xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-2xl gradient-bg flex items-center justify-center">
              <span className="text-white font-bold text-lg">Q</span>
            </div>
            <span className="text-xl font-bold hidden sm:block">Quote of the Day</span>
          </Link>

          <nav className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-surface-600 hover:text-surface-900 transition-colors">
              Home
            </Link>
            <Link to="/browse" className="text-surface-600 hover:text-surface-900 transition-colors">
              Browse
            </Link>
            <Link to="/categories" className="text-surface-600 hover:text-surface-900 transition-colors">
              Categories
            </Link>
            <Link to="/authors" className="text-surface-600 hover:text-surface-900 transition-colors">
              Authors
            </Link>
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/search"
              className="p-2 rounded-full hover:bg-surface-100 transition-colors"
            >
              <Search size={20} className="text-surface-600" />
            </Link>
            <ThemeToggle />
            <button
              className="md:hidden p-2 rounded-full hover:bg-surface-100 transition-colors"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-surface-200 pt-4 flex flex-col gap-4">
            <Link to="/" className="text-surface-600 hover:text-surface-900 transition-colors" onClick={() => setIsMenuOpen(false)}>
              Home
            </Link>
            <Link to="/browse" className="text-surface-600 hover:text-surface-900 transition-colors" onClick={() => setIsMenuOpen(false)}>
              Browse
            </Link>
            <Link to="/categories" className="text-surface-600 hover:text-surface-900 transition-colors" onClick={() => setIsMenuOpen(false)}>
              Categories
            </Link>
            <Link to="/authors" className="text-surface-600 hover:text-surface-900 transition-colors" onClick={() => setIsMenuOpen(false)}>
              Authors
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
}
